import {
  faBuilding,
  faDatabase,
  faUser,
  IconDefinition,
} from '@fortawesome/pro-light-svg-icons';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarItemsContainer from '../sidebar/SidebarItemsContainer';
import SidebarItem from '../sidebar/SidebarItem';

interface NavItem {
  key: string;
  label: string;
  link: string;
  icon: IconDefinition;
  pathPrefix: string;
}

const items: NavItem[] = [
  {
    key: 'company',
    label: 'Einstellungen',
    link: '/companyAdmin/company',
    pathPrefix: '/companyAdmin/company',
    icon: faBuilding,
  },
  {
    key: 'users',
    label: 'Benutzer',
    link: '/companyAdmin/users',
    pathPrefix: '/companyAdmin/users',
    icon: faUser,
  },
  {
    key: 'knowledgeBases',
    label: 'Wissensdatenbanken',
    link: '/companyAdmin/knowledgeBases',
    pathPrefix: '/companyAdmin/knowledgeBase',
    icon: faDatabase,
  },
];

const CompanyAdminSidebar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <SidebarItemsContainer>
      {items.map((item) => (
        <SidebarItem
          key={item.key}
          label={item.label}
          icon={item.icon}
          onClick={() => navigate(item.link)}
          isActive={pathname.startsWith(item.pathPrefix)}
        />
      ))}
    </SidebarItemsContainer>
  );
};

export default CompanyAdminSidebar;
